/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Component } from "./component";
import { conversationCommandTypeFromJSON, conversationCommandTypeToJSON, } from "./conversation";
import { Timestamp } from "./google/protobuf/timestamp";
import { StringValue } from "./google/protobuf/wrappers";
export var ConversationMessageAdditionalDataKey;
(function (ConversationMessageAdditionalDataKey) {
    ConversationMessageAdditionalDataKey[ConversationMessageAdditionalDataKey["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ConversationMessageAdditionalDataKey[ConversationMessageAdditionalDataKey["NEW_INTENT"] = 1] = "NEW_INTENT";
})(ConversationMessageAdditionalDataKey || (ConversationMessageAdditionalDataKey = {}));
export function conversationMessageAdditionalDataKeyFromJSON(object) {
    switch (object) {
        case 0:
        case "CONVERSATION_MESSAGE_ADDITIONAL_DATA_KEY_UNSPECIFIED":
            return ConversationMessageAdditionalDataKey.UNSPECIFIED;
        case 1:
        case "CONVERSATION_MESSAGE_ADDITIONAL_DATA_KEY_NEW_INTENT":
            return ConversationMessageAdditionalDataKey.NEW_INTENT;
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ConversationMessageAdditionalDataKey");
    }
}
export function conversationMessageAdditionalDataKeyToJSON(object) {
    switch (object) {
        case ConversationMessageAdditionalDataKey.UNSPECIFIED:
            return "CONVERSATION_MESSAGE_ADDITIONAL_DATA_KEY_UNSPECIFIED";
        case ConversationMessageAdditionalDataKey.NEW_INTENT:
            return "CONVERSATION_MESSAGE_ADDITIONAL_DATA_KEY_NEW_INTENT";
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ConversationMessageAdditionalDataKey");
    }
}
function createBaseConversationMessageAdditionalDataMapEntry() {
    return { key: 0, value: "" };
}
export const ConversationMessageAdditionalDataMapEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== 0) {
            writer.uint32(8).int32(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationMessageAdditionalDataMapEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 8) {
                        break;
                    }
                    message.key = reader.int32();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? conversationMessageAdditionalDataKeyFromJSON(object.key) : 0,
            value: isSet(object.value) ? String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = conversationMessageAdditionalDataKeyToJSON(message.key));
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    create(base) {
        return ConversationMessageAdditionalDataMapEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationMessageAdditionalDataMapEntry();
        message.key = object.key ?? 0;
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseConversationMetadata() {
    return { applicationId: "", clientId: "", ipAddress: undefined, deviceFamily: undefined };
}
export const ConversationMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.applicationId !== "") {
            writer.uint32(10).string(message.applicationId);
        }
        if (message.clientId !== "") {
            writer.uint32(18).string(message.clientId);
        }
        if (message.ipAddress !== undefined) {
            StringValue.encode({ value: message.ipAddress }, writer.uint32(26).fork()).ldelim();
        }
        if (message.deviceFamily !== undefined) {
            StringValue.encode({ value: message.deviceFamily }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.applicationId = reader.string();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.clientId = reader.string();
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.ipAddress = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag != 34) {
                        break;
                    }
                    message.deviceFamily = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            applicationId: isSet(object.applicationId) ? String(object.applicationId) : "",
            clientId: isSet(object.clientId) ? String(object.clientId) : "",
            ipAddress: isSet(object.ipAddress) ? String(object.ipAddress) : undefined,
            deviceFamily: isSet(object.deviceFamily) ? String(object.deviceFamily) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.applicationId !== undefined && (obj.applicationId = message.applicationId);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.ipAddress !== undefined && (obj.ipAddress = message.ipAddress);
        message.deviceFamily !== undefined && (obj.deviceFamily = message.deviceFamily);
        return obj;
    },
    create(base) {
        return ConversationMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationMetadata();
        message.applicationId = object.applicationId ?? "";
        message.clientId = object.clientId ?? "";
        message.ipAddress = object.ipAddress ?? undefined;
        message.deviceFamily = object.deviceFamily ?? undefined;
        return message;
    },
};
function createBaseConversationMessage() {
    return {
        message: undefined,
        customerId: undefined,
        workspaceId: undefined,
        conversationCommand: 0,
        requestId: "",
        timestamp: undefined,
        metadata: undefined,
        channel: undefined,
        additionalData: [],
    };
}
export const ConversationMessage = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.message !== undefined) {
            StringValue.encode({ value: message.message }, writer.uint32(10).fork()).ldelim();
        }
        if (message.customerId !== undefined) {
            StringValue.encode({ value: message.customerId }, writer.uint32(18).fork()).ldelim();
        }
        if (message.workspaceId !== undefined) {
            StringValue.encode({ value: message.workspaceId }, writer.uint32(26).fork()).ldelim();
        }
        if (message.conversationCommand !== 0) {
            writer.uint32(32).int32(message.conversationCommand);
        }
        if (message.requestId !== "") {
            writer.uint32(42).string(message.requestId);
        }
        if (message.timestamp !== undefined) {
            Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(50).fork()).ldelim();
        }
        if (message.metadata !== undefined) {
            ConversationMetadata.encode(message.metadata, writer.uint32(58).fork()).ldelim();
        }
        if (message.channel !== undefined) {
            ConversationChannel.encode(message.channel, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.additionalData) {
            ConversationMessageAdditionalDataMapEntry.encode(v, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.message = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.customerId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.workspaceId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag != 32) {
                        break;
                    }
                    message.conversationCommand = reader.int32();
                    continue;
                case 5:
                    if (tag != 42) {
                        break;
                    }
                    message.requestId = reader.string();
                    continue;
                case 6:
                    if (tag != 50) {
                        break;
                    }
                    message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag != 58) {
                        break;
                    }
                    message.metadata = ConversationMetadata.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag != 66) {
                        break;
                    }
                    message.channel = ConversationChannel.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag != 74) {
                        break;
                    }
                    message.additionalData.push(ConversationMessageAdditionalDataMapEntry.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? String(object.message) : undefined,
            customerId: isSet(object.customerId) ? String(object.customerId) : undefined,
            workspaceId: isSet(object.workspaceId) ? String(object.workspaceId) : undefined,
            conversationCommand: isSet(object.conversationCommand)
                ? conversationCommandTypeFromJSON(object.conversationCommand)
                : 0,
            requestId: isSet(object.requestId) ? String(object.requestId) : "",
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            metadata: isSet(object.metadata) ? ConversationMetadata.fromJSON(object.metadata) : undefined,
            channel: isSet(object.channel) ? ConversationChannel.fromJSON(object.channel) : undefined,
            additionalData: Array.isArray(object?.additionalData)
                ? object.additionalData.map((e) => ConversationMessageAdditionalDataMapEntry.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        message.customerId !== undefined && (obj.customerId = message.customerId);
        message.workspaceId !== undefined && (obj.workspaceId = message.workspaceId);
        message.conversationCommand !== undefined &&
            (obj.conversationCommand = conversationCommandTypeToJSON(message.conversationCommand));
        message.requestId !== undefined && (obj.requestId = message.requestId);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.metadata !== undefined &&
            (obj.metadata = message.metadata ? ConversationMetadata.toJSON(message.metadata) : undefined);
        message.channel !== undefined &&
            (obj.channel = message.channel ? ConversationChannel.toJSON(message.channel) : undefined);
        if (message.additionalData) {
            obj.additionalData = message.additionalData.map((e) => e ? ConversationMessageAdditionalDataMapEntry.toJSON(e) : undefined);
        }
        else {
            obj.additionalData = [];
        }
        return obj;
    },
    create(base) {
        return ConversationMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationMessage();
        message.message = object.message ?? undefined;
        message.customerId = object.customerId ?? undefined;
        message.workspaceId = object.workspaceId ?? undefined;
        message.conversationCommand = object.conversationCommand ?? 0;
        message.requestId = object.requestId ?? "";
        message.timestamp = object.timestamp ?? undefined;
        message.metadata = (object.metadata !== undefined && object.metadata !== null)
            ? ConversationMetadata.fromPartial(object.metadata)
            : undefined;
        message.channel = (object.channel !== undefined && object.channel !== null)
            ? ConversationChannel.fromPartial(object.channel)
            : undefined;
        message.additionalData =
            object.additionalData?.map((e) => ConversationMessageAdditionalDataMapEntry.fromPartial(e)) || [];
        return message;
    },
};
function createBaseConversationResponse() {
    return {
        components: [],
        customerId: "",
        workspaceId: "",
        conversationCommand: 0,
        requestId: "",
        timestamp: undefined,
        metadata: undefined,
        channel: undefined,
    };
}
export const ConversationResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.components) {
            Component.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.customerId !== "") {
            writer.uint32(18).string(message.customerId);
        }
        if (message.workspaceId !== "") {
            writer.uint32(26).string(message.workspaceId);
        }
        if (message.conversationCommand !== 0) {
            writer.uint32(32).int32(message.conversationCommand);
        }
        if (message.requestId !== "") {
            writer.uint32(42).string(message.requestId);
        }
        if (message.timestamp !== undefined) {
            Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(50).fork()).ldelim();
        }
        if (message.metadata !== undefined) {
            ConversationMetadata.encode(message.metadata, writer.uint32(58).fork()).ldelim();
        }
        if (message.channel !== undefined) {
            ConversationChannel.encode(message.channel, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.components.push(Component.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.customerId = reader.string();
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.workspaceId = reader.string();
                    continue;
                case 4:
                    if (tag != 32) {
                        break;
                    }
                    message.conversationCommand = reader.int32();
                    continue;
                case 5:
                    if (tag != 42) {
                        break;
                    }
                    message.requestId = reader.string();
                    continue;
                case 6:
                    if (tag != 50) {
                        break;
                    }
                    message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag != 58) {
                        break;
                    }
                    message.metadata = ConversationMetadata.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag != 66) {
                        break;
                    }
                    message.channel = ConversationChannel.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            components: Array.isArray(object?.components) ? object.components.map((e) => Component.fromJSON(e)) : [],
            customerId: isSet(object.customerId) ? String(object.customerId) : "",
            workspaceId: isSet(object.workspaceId) ? String(object.workspaceId) : "",
            conversationCommand: isSet(object.conversationCommand)
                ? conversationCommandTypeFromJSON(object.conversationCommand)
                : 0,
            requestId: isSet(object.requestId) ? String(object.requestId) : "",
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            metadata: isSet(object.metadata) ? ConversationMetadata.fromJSON(object.metadata) : undefined,
            channel: isSet(object.channel) ? ConversationChannel.fromJSON(object.channel) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.components) {
            obj.components = message.components.map((e) => e ? Component.toJSON(e) : undefined);
        }
        else {
            obj.components = [];
        }
        message.customerId !== undefined && (obj.customerId = message.customerId);
        message.workspaceId !== undefined && (obj.workspaceId = message.workspaceId);
        message.conversationCommand !== undefined &&
            (obj.conversationCommand = conversationCommandTypeToJSON(message.conversationCommand));
        message.requestId !== undefined && (obj.requestId = message.requestId);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.metadata !== undefined &&
            (obj.metadata = message.metadata ? ConversationMetadata.toJSON(message.metadata) : undefined);
        message.channel !== undefined &&
            (obj.channel = message.channel ? ConversationChannel.toJSON(message.channel) : undefined);
        return obj;
    },
    create(base) {
        return ConversationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationResponse();
        message.components = object.components?.map((e) => Component.fromPartial(e)) || [];
        message.customerId = object.customerId ?? "";
        message.workspaceId = object.workspaceId ?? "";
        message.conversationCommand = object.conversationCommand ?? 0;
        message.requestId = object.requestId ?? "";
        message.timestamp = object.timestamp ?? undefined;
        message.metadata = (object.metadata !== undefined && object.metadata !== null)
            ? ConversationMetadata.fromPartial(object.metadata)
            : undefined;
        message.channel = (object.channel !== undefined && object.channel !== null)
            ? ConversationChannel.fromPartial(object.channel)
            : undefined;
        return message;
    },
};
function createBaseConversationChannel() {
    return { data: undefined };
}
export const ConversationChannel = {
    encode(message, writer = _m0.Writer.create()) {
        switch (message.data?.$case) {
            case "unknown":
                ConversationChannelDataUnknown.encode(message.data.unknown, writer.uint32(10).fork()).ldelim();
                break;
            case "dashboardChatWidget":
                ConversationChannelDataChatWidget.encode(message.data.dashboardChatWidget, writer.uint32(18).fork()).ldelim();
                break;
            case "liveChatWidget":
                ConversationChannelDataChatWidget.encode(message.data.liveChatWidget, writer.uint32(26).fork()).ldelim();
                break;
            case "freshChat":
                ConversationChannelDataFreshChat.encode(message.data.freshChat, writer.uint32(34).fork()).ldelim();
                break;
            case "slack":
                ConversationChannelDataSlack.encode(message.data.slack, writer.uint32(42).fork()).ldelim();
                break;
            case "teams":
                ConversationChannelDataTeams.encode(message.data.teams, writer.uint32(50).fork()).ldelim();
                break;
            case "zendesk":
                ConversationChannelDataZendesk.encode(message.data.zendesk, writer.uint32(58).fork()).ldelim();
                break;
            case "snapEngage":
                ConversationChannelDataSnapEngage.encode(message.data.snapEngage, writer.uint32(66).fork()).ldelim();
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.data = { $case: "unknown", unknown: ConversationChannelDataUnknown.decode(reader, reader.uint32()) };
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.data = {
                        $case: "dashboardChatWidget",
                        dashboardChatWidget: ConversationChannelDataChatWidget.decode(reader, reader.uint32()),
                    };
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.data = {
                        $case: "liveChatWidget",
                        liveChatWidget: ConversationChannelDataChatWidget.decode(reader, reader.uint32()),
                    };
                    continue;
                case 4:
                    if (tag != 34) {
                        break;
                    }
                    message.data = {
                        $case: "freshChat",
                        freshChat: ConversationChannelDataFreshChat.decode(reader, reader.uint32()),
                    };
                    continue;
                case 5:
                    if (tag != 42) {
                        break;
                    }
                    message.data = { $case: "slack", slack: ConversationChannelDataSlack.decode(reader, reader.uint32()) };
                    continue;
                case 6:
                    if (tag != 50) {
                        break;
                    }
                    message.data = { $case: "teams", teams: ConversationChannelDataTeams.decode(reader, reader.uint32()) };
                    continue;
                case 7:
                    if (tag != 58) {
                        break;
                    }
                    message.data = { $case: "zendesk", zendesk: ConversationChannelDataZendesk.decode(reader, reader.uint32()) };
                    continue;
                case 8:
                    if (tag != 66) {
                        break;
                    }
                    message.data = {
                        $case: "snapEngage",
                        snapEngage: ConversationChannelDataSnapEngage.decode(reader, reader.uint32()),
                    };
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: isSet(object.unknown)
                ? { $case: "unknown", unknown: ConversationChannelDataUnknown.fromJSON(object.unknown) }
                : isSet(object.dashboardChatWidget)
                    ? {
                        $case: "dashboardChatWidget",
                        dashboardChatWidget: ConversationChannelDataChatWidget.fromJSON(object.dashboardChatWidget),
                    }
                    : isSet(object.liveChatWidget)
                        ? { $case: "liveChatWidget", liveChatWidget: ConversationChannelDataChatWidget.fromJSON(object.liveChatWidget) }
                        : isSet(object.freshChat)
                            ? { $case: "freshChat", freshChat: ConversationChannelDataFreshChat.fromJSON(object.freshChat) }
                            : isSet(object.slack)
                                ? { $case: "slack", slack: ConversationChannelDataSlack.fromJSON(object.slack) }
                                : isSet(object.teams)
                                    ? { $case: "teams", teams: ConversationChannelDataTeams.fromJSON(object.teams) }
                                    : isSet(object.zendesk)
                                        ? { $case: "zendesk", zendesk: ConversationChannelDataZendesk.fromJSON(object.zendesk) }
                                        : isSet(object.snapEngage)
                                            ? { $case: "snapEngage", snapEngage: ConversationChannelDataSnapEngage.fromJSON(object.snapEngage) }
                                            : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.data?.$case === "unknown" &&
            (obj.unknown = message.data?.unknown ? ConversationChannelDataUnknown.toJSON(message.data?.unknown) : undefined);
        message.data?.$case === "dashboardChatWidget" && (obj.dashboardChatWidget = message.data?.dashboardChatWidget
            ? ConversationChannelDataChatWidget.toJSON(message.data?.dashboardChatWidget)
            : undefined);
        message.data?.$case === "liveChatWidget" && (obj.liveChatWidget = message.data?.liveChatWidget
            ? ConversationChannelDataChatWidget.toJSON(message.data?.liveChatWidget)
            : undefined);
        message.data?.$case === "freshChat" && (obj.freshChat = message.data?.freshChat
            ? ConversationChannelDataFreshChat.toJSON(message.data?.freshChat)
            : undefined);
        message.data?.$case === "slack" &&
            (obj.slack = message.data?.slack ? ConversationChannelDataSlack.toJSON(message.data?.slack) : undefined);
        message.data?.$case === "teams" &&
            (obj.teams = message.data?.teams ? ConversationChannelDataTeams.toJSON(message.data?.teams) : undefined);
        message.data?.$case === "zendesk" &&
            (obj.zendesk = message.data?.zendesk ? ConversationChannelDataZendesk.toJSON(message.data?.zendesk) : undefined);
        message.data?.$case === "snapEngage" && (obj.snapEngage = message.data?.snapEngage
            ? ConversationChannelDataSnapEngage.toJSON(message.data?.snapEngage)
            : undefined);
        return obj;
    },
    create(base) {
        return ConversationChannel.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationChannel();
        if (object.data?.$case === "unknown" && object.data?.unknown !== undefined && object.data?.unknown !== null) {
            message.data = { $case: "unknown", unknown: ConversationChannelDataUnknown.fromPartial(object.data.unknown) };
        }
        if (object.data?.$case === "dashboardChatWidget" &&
            object.data?.dashboardChatWidget !== undefined &&
            object.data?.dashboardChatWidget !== null) {
            message.data = {
                $case: "dashboardChatWidget",
                dashboardChatWidget: ConversationChannelDataChatWidget.fromPartial(object.data.dashboardChatWidget),
            };
        }
        if (object.data?.$case === "liveChatWidget" &&
            object.data?.liveChatWidget !== undefined &&
            object.data?.liveChatWidget !== null) {
            message.data = {
                $case: "liveChatWidget",
                liveChatWidget: ConversationChannelDataChatWidget.fromPartial(object.data.liveChatWidget),
            };
        }
        if (object.data?.$case === "freshChat" && object.data?.freshChat !== undefined && object.data?.freshChat !== null) {
            message.data = {
                $case: "freshChat",
                freshChat: ConversationChannelDataFreshChat.fromPartial(object.data.freshChat),
            };
        }
        if (object.data?.$case === "slack" && object.data?.slack !== undefined && object.data?.slack !== null) {
            message.data = { $case: "slack", slack: ConversationChannelDataSlack.fromPartial(object.data.slack) };
        }
        if (object.data?.$case === "teams" && object.data?.teams !== undefined && object.data?.teams !== null) {
            message.data = { $case: "teams", teams: ConversationChannelDataTeams.fromPartial(object.data.teams) };
        }
        if (object.data?.$case === "zendesk" && object.data?.zendesk !== undefined && object.data?.zendesk !== null) {
            message.data = { $case: "zendesk", zendesk: ConversationChannelDataZendesk.fromPartial(object.data.zendesk) };
        }
        if (object.data?.$case === "snapEngage" && object.data?.snapEngage !== undefined && object.data?.snapEngage !== null) {
            message.data = {
                $case: "snapEngage",
                snapEngage: ConversationChannelDataSnapEngage.fromPartial(object.data.snapEngage),
            };
        }
        return message;
    },
};
function createBaseConversationChannelDataUnknown() {
    return {};
}
export const ConversationChannelDataUnknown = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannelDataUnknown();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return ConversationChannelDataUnknown.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConversationChannelDataUnknown();
        return message;
    },
};
function createBaseConversationChannelDataChatWidget() {
    return {};
}
export const ConversationChannelDataChatWidget = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannelDataChatWidget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return ConversationChannelDataChatWidget.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConversationChannelDataChatWidget();
        return message;
    },
};
function createBaseConversationChannelDataFreshChat() {
    return { freshChatConversationId: "" };
}
export const ConversationChannelDataFreshChat = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.freshChatConversationId !== "") {
            writer.uint32(10).string(message.freshChatConversationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannelDataFreshChat();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.freshChatConversationId = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            freshChatConversationId: isSet(object.freshChatConversationId) ? String(object.freshChatConversationId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.freshChatConversationId !== undefined && (obj.freshChatConversationId = message.freshChatConversationId);
        return obj;
    },
    create(base) {
        return ConversationChannelDataFreshChat.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationChannelDataFreshChat();
        message.freshChatConversationId = object.freshChatConversationId ?? "";
        return message;
    },
};
function createBaseConversationChannelDataSlack() {
    return { slackChannel: "", slackUser: "", slackTeamId: "" };
}
export const ConversationChannelDataSlack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.slackChannel !== "") {
            writer.uint32(10).string(message.slackChannel);
        }
        if (message.slackUser !== "") {
            writer.uint32(18).string(message.slackUser);
        }
        if (message.slackTeamId !== "") {
            writer.uint32(26).string(message.slackTeamId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannelDataSlack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.slackChannel = reader.string();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.slackUser = reader.string();
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.slackTeamId = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            slackChannel: isSet(object.slackChannel) ? String(object.slackChannel) : "",
            slackUser: isSet(object.slackUser) ? String(object.slackUser) : "",
            slackTeamId: isSet(object.slackTeamId) ? String(object.slackTeamId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.slackChannel !== undefined && (obj.slackChannel = message.slackChannel);
        message.slackUser !== undefined && (obj.slackUser = message.slackUser);
        message.slackTeamId !== undefined && (obj.slackTeamId = message.slackTeamId);
        return obj;
    },
    create(base) {
        return ConversationChannelDataSlack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationChannelDataSlack();
        message.slackChannel = object.slackChannel ?? "";
        message.slackUser = object.slackUser ?? "";
        message.slackTeamId = object.slackTeamId ?? "";
        return message;
    },
};
function createBaseConversationChannelDataTeams() {
    return {};
}
export const ConversationChannelDataTeams = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannelDataTeams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return ConversationChannelDataTeams.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConversationChannelDataTeams();
        return message;
    },
};
function createBaseConversationChannelDataZendesk() {
    return { zendeskTicketId: "" };
}
export const ConversationChannelDataZendesk = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.zendeskTicketId !== "") {
            writer.uint32(10).string(message.zendeskTicketId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannelDataZendesk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.zendeskTicketId = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { zendeskTicketId: isSet(object.zendeskTicketId) ? String(object.zendeskTicketId) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.zendeskTicketId !== undefined && (obj.zendeskTicketId = message.zendeskTicketId);
        return obj;
    },
    create(base) {
        return ConversationChannelDataZendesk.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationChannelDataZendesk();
        message.zendeskTicketId = object.zendeskTicketId ?? "";
        return message;
    },
};
function createBaseConversationChannelDataSnapEngage() {
    return { snapEngageChatId: "", snapEngageApplicationId: "" };
}
export const ConversationChannelDataSnapEngage = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.snapEngageChatId !== "") {
            writer.uint32(10).string(message.snapEngageChatId);
        }
        if (message.snapEngageApplicationId !== "") {
            writer.uint32(18).string(message.snapEngageApplicationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConversationChannelDataSnapEngage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.snapEngageChatId = reader.string();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.snapEngageApplicationId = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            snapEngageChatId: isSet(object.snapEngageChatId) ? String(object.snapEngageChatId) : "",
            snapEngageApplicationId: isSet(object.snapEngageApplicationId) ? String(object.snapEngageApplicationId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.snapEngageChatId !== undefined && (obj.snapEngageChatId = message.snapEngageChatId);
        message.snapEngageApplicationId !== undefined && (obj.snapEngageApplicationId = message.snapEngageApplicationId);
        return obj;
    },
    create(base) {
        return ConversationChannelDataSnapEngage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConversationChannelDataSnapEngage();
        message.snapEngageChatId = object.snapEngageChatId ?? "";
        message.snapEngageApplicationId = object.snapEngageApplicationId ?? "";
        return message;
    },
};
var tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function toTimestamp(date) {
    const seconds = date.getTime() / 1_000;
    const nanos = (date.getTime() % 1_000) * 1_000_000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds * 1_000;
    millis += t.nanos / 1_000_000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
function isSet(value) {
    return value !== null && value !== undefined;
}
